var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"open-button",on:{"click":function($event){return _vm.IrParaUrl('https://api.whatsapp.com/send?phone=553333226363')}}},[_c('img',{attrs:{"src":require("../assets/img/whats.svg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }